export enum SortType {
  ASC = 'asc',
  DESC = 'desc',
  DEFAULT = 'none',
}

export interface ApiColumnFilters {
  dateFrom?: Date;
  dateTo?: Date;
  search?: string;
  checkbox?: string[];
}

export interface PagingParams {
  page?: number;
  size?: number;
  sort?: SortingParams[];
  search?: string;
  filter?: {
    column: string;
    filters: ApiColumnFilters;
  }[];
}

export interface SortingParams {
  column: string;
  sort: SortType;
}
